<div class="program-radio card">
  <h4 [innerHTML]="programNode?.labelText"></h4>
  <span
    class="label-highlight"
    *ngIf="programNode?.description"
    [innerHTML]="programNode?.description"
  ></span>
  <div class="program-radio__options">
    <mat-radio-group [(ngModel)]="value" class="program-radio__radio-group">
      <mat-radio-button
        *ngFor="let item of programNode?.values"
        [value]="item.value"
        (click)="$event.stopPropagation()"
        (change)="selectItem(item.value)"
        ><span (click)="$event.stopPropagation()">
          {{ item.label || item.name }}
        </span></mat-radio-button
      >
    </mat-radio-group>
  </div>
</div>
